var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWecom = function SvgWecom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.668.276c-3.279.357-6.26 1.76-8.391 3.95a11.2 11.2 0 0 0-2.04 2.872 10.025 10.025 0 0 0-1.045 4.455c0 1.988.605 3.948 1.75 5.67a15.65 15.65 0 0 0 2.4 2.742v.002l-.394 3.098c-.016.042-.033.084-.042.129-.01.04-.012.082-.016.123-.002.032-.01.063-.01.095 0 .035.008.068.01.102.053.51.478.909 1.001.909a.996.996 0 0 0 .499-.137l.014-.008c.022-.012.044-.023.064-.038l.942-.473 2.806-1.408c.806.232 1.607.38 2.45.472.549.06 1.105.092 1.655.092.56 0 1.142-.034 1.727-.1a14.717 14.717 0 0 0 3.308-.774 1.825 1.825 0 0 1-1.243-1.908c-.75.238-1.535.41-2.345.501-.492.056-.979.085-1.447.085-.46 0-.925-.026-1.385-.076-.095-.01-.191-.026-.287-.039a12.515 12.515 0 0 1-1.856-.388 1.27 1.27 0 0 0-.386-.06c-.208 0-.409.056-.613.161-.027.014-.053.025-.08.04l-2.304 1.36-.1.058-.002.001c-.05.03-.079.04-.104.04a.156.156 0 0 1-.154-.159l.09-.359.102-.39.168-.64.187-.714a.968.968 0 0 0-.348-1.076 10.443 10.443 0 0 1-.963-.81 9.429 9.429 0 0 1-1.366-1.614c-.906-1.363-1.385-2.91-1.385-4.472 0-1.213.277-2.392.824-3.506a8.99 8.99 0 0 1 1.636-2.301C6.748 3.98 9.213 2.827 11.936 2.53c.474-.052.94-.078 1.385-.078.468 0 .954.028 1.447.084 2.71.308 5.16 1.47 6.9 3.268a8.976 8.976 0 0 1 1.627 2.307 7.892 7.892 0 0 1 .811 3.478c0 .124-.008.25-.014.374a1.823 1.823 0 0 1 2.241.262c.03.031.057.065.084.097a9.87 9.87 0 0 0 .032-.77c0-1.53-.346-3.017-1.029-4.42a11.175 11.175 0 0 0-2.028-2.878c-2.117-2.19-5.08-3.6-8.344-3.97A15.315 15.315 0 0 0 13.32.183c-.533 0-1.09.03-1.653.092z",
    id: "wecom_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.349.257A.436.436 0 0 0 .318.84l.03.035c.02.019.04.035.062.05.042.04.085.08.126.122a5.613 5.613 0 0 1 1.541 2.876 1.827 1.827 0 0 0 .06.37h.001a1.825 1.825 0 0 0 3.051.809 1.825 1.825 0 0 0 0-2.581 1.817 1.817 0 0 0-.88-.488 1.937 1.937 0 0 0-.22-.037h.001A5.607 5.607 0 0 1 1.142.44 4.95 4.95 0 0 1 .966.257a.435.435 0 0 0-.617 0z",
    id: "wecom_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.524.577a1.822 1.822 0 0 0-.488.88 2.01 2.01 0 0 0-.037.22A5.61 5.61 0 0 1 .444 4.625c-.06.06-.121.119-.183.175a.437.437 0 0 0 .583.648.474.474 0 0 0 .085-.092v.001l.121-.126A5.609 5.609 0 0 1 3.927 3.69a1.689 1.689 0 0 0 .37-.061 1.826 1.826 0 0 0 .81-3.051h-.001A1.82 1.82 0 0 0 3.815.042a1.82 1.82 0 0 0-1.291.534z",
    id: "wecom_svg__d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.58.661a1.827 1.827 0 0 0 0 2.582c.252.251.558.414.88.488a1.785 1.785 0 0 0 .22.037 5.61 5.61 0 0 1 2.948 1.554c.06.06.12.122.176.184a.437.437 0 0 0 .648-.583.424.424 0 0 0-.092-.085A5.612 5.612 0 0 1 3.693 1.84v.001a1.928 1.928 0 0 0-.06-.37A1.82 1.82 0 0 0 1.871.126a1.82 1.82 0 0 0-1.29.535z",
    id: "wecom_svg__f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.927.314a.434.434 0 0 0-.085.092 5.604 5.604 0 0 1-2.998 1.667 1.694 1.694 0 0 0-.37.061v.001a1.826 1.826 0 0 0-.81 3.051 1.826 1.826 0 0 0 2.583 0 1.803 1.803 0 0 0 .509-.99v.001l.015-.11a5.613 5.613 0 0 1 1.555-2.949c.06-.06.122-.118.184-.175A.435.435 0 0 0 5.2.218a.436.436 0 0 0-.274.096z",
    id: "wecom_svg__h"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#0082EF",
    xlinkHref: "#wecom_svg__a",
    transform: "translate(2 5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.985 25.985)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wecom_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wecom_svg__b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FB6500",
    mask: "url(#wecom_svg__c)",
    d: "M.029 5.83h5.888V-.064H.029z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.231 22.78)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wecom_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wecom_svg__d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0082EF",
    mask: "url(#wecom_svg__e)",
    d: "M-.06 5.738h5.893V-.15H-.06z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.025 17.533)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wecom_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wecom_svg__f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DBC00",
    mask: "url(#wecom_svg__g)",
    d: "M-.146 5.827H5.74V-.066H-.146z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.78 20.739)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wecom_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wecom_svg__h"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    mask: "url(#wecom_svg__i)",
    d: "M-.063 5.913H5.83V.025H-.063z"
  })))));
};
export { SvgWecom as ReactComponent };
export default __webpack_public_path__ + "img/wecom.c24ff6c339bd3df49cbacab747555243.svg";